import { InternalLink } from 'src/components/atoms/Link'
import { SanityImage } from 'src/components/atoms/SanityImage'

import { NativeTreeSpecies } from 'src/config/generated/sanitySchema'
import { nativeTreeSpeciesPath } from 'src/config/paths'

export const SpeciesTile = ({
  image,
  name,
  scientificName,
  slug
}: NativeTreeSpecies) => {
  return (
    <InternalLink
      color='black'
      className='w-full md:w-[275px] hover:shadow-[0px_0px_20px_0px_rgba(0,0,0,0.25)] transition-shadow duration-300 overflow-clip rounded-[10px]'
      href={nativeTreeSpeciesPath({ routeParams: { slug: slug.current } })}
    >
      <div className='flex flex-col w-full bg-white!'>
        <div className='relative aspect-[0.92] object-cover'>
          <SanityImage
            className='object-cover'
            source={image}
            alt={`an illustration of a ${name} tree`}
            fill
          />
        </div>
        <div className='flex flex-col gap-[15px] md:gap-[10px] h-[100px] md:h-[120px] justify-center p-[20px] md:p-[30px]'>
          <span className='text-[18px] leading-[25px] md:text-[20px] md:leading-[26px] font-bold'>
            {name}
          </span>
          <span className='text-[14px] leading-[20px] md:text-[16px] md:leading-[24px] font-medium'>
            {scientificName}
          </span>
        </div>
      </div>
    </InternalLink>
  )
}
